import { Observable } from 'rxjs';
import { Role } from '../../../models';

export abstract class IRoleOverrideService {
  abstract getOverriddenRole$(): Observable<Role | null>;

  abstract setOverriddenRole(role: Role | null): void;
}
